import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";
import styles from "./BulkActions.module.css";

interface Props {
  assetTypeLabel: string;
  closeDropdown: () => void;
  clearSelectedEntities: () => void;
  selectAllEntities: () => void;
  selectedCount: number;
  selectableCount: number;
}

const getBulkSelectIcon = (selectedCount: number, selectableCount: number) => {
  if (selectedCount === selectableCount && selectableCount > 0) {
    return "formCheckSquare";
  } else if (selectedCount && selectedCount < selectableCount) {
    return "formDashSquare";
  }
  return "formBlank";
};

export function BulkActionsCheckbox({
  assetTypeLabel,
  closeDropdown,
  clearSelectedEntities,
  selectAllEntities,
  selectedCount,
  selectableCount,
}: Props) {
  const t = useTranslations("bulk-actions-checkbox");

  return (
    <button
      aria-label={t("accessibility.toggle-all-selected", { assetTypeLabel })}
      className={`${styles.bulkEditButton}  ${selectedCount && styles.bulkEditButtonSelected}`}
      onClick={() => {
        closeDropdown();
        if (selectedCount) {
          clearSelectedEntities();
        } else {
          selectAllEntities();
        }
      }}
    >
      <Icon
        name={getBulkSelectIcon(selectedCount, selectableCount)}
        size={24}
      />
    </button>
  );
}
